<template>
    <Header
        :elements="countElements"
        :current="currentElement"
    ></Header>
    <div class="MuiBox-root css-3d0ymh">
        <div class="MuiBox-root css-19vwmxk" data-testid="screen-business_details" tabindex="-1">
            <div class="MuiBox-root css-1n2tziu">
                <div class="MuiGrid-root MuiGrid-container css-15zova9 slide-up-enter-done" transition="250">
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-3 MuiGrid-grid-md-4 css-4lvwcn">
                        <div class="MuiBox-root css-1yu9eo3">
                            <div class="MuiGrid-root css-skpbsy">
                                <div class="MuiGrid-root css-vnk25j" type="lottie">
                                    <div>
                                        <Freezeframe
                                            src="/images/free-animated-icon-fast-forward-7740748.gif"
                                        ></Freezeframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-1 css-se8e58">
                        <div class="MuiBox-root css-8atqhb"></div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4 MuiGrid-grid-md-7 css-xjtbym">
                        <div class="module-checkout">
                            <div class="checkDetail">
                                <div>
                                    <div class="inputSec">
                                        <h2 class="topSpace topSpace_with-dot" style="color:#000"><b>Class {{ code }} - {{ name }}</b></h2>
                                        <p><b>{{ description }}</b></p>
                                        <div style="margin: 10px 0px;">
                                            <p>Please confirm the class you want to file the statement of use extension.</p>
                                            <RadioCheckbox
                                                :value="is_selected"
                                                @change_c="is_selected = $event"
                                                type="radio"
                                                value_v="1"
                                                text="Yes"
                                                name="is_usifalseng_trademark"
                                            ></RadioCheckbox>
                                            <RadioCheckbox
                                                :value="is_selected"
                                                @change_c="is_selected = $event"
                                                type="radio"
                                                value_v="0"
                                                text="No"
                                                name="is_using_trademark"
                                            ></RadioCheckbox>
                                        </div>
                                    </div>
                                    <!-- "Repeater" ends -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="css-1l6i970">
                <div class="css-1c73k7k">
                    <BottomButton
                        :active="true"
                        @click.native="back"
                        text="Back"
                        class_b="button-back"
                    ></BottomButton>
                    <BottomButton
                        :active="true"
                        @click.native="next"
                        text="Next"
                        class_b="button-next"
                    ></BottomButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Freezeframe from '@/components/Freezeframe.vue'
import Header from '@/components/Header-Short-New.vue'
import BottomButton from '@/ui/Bottom-Button.vue'
import http from "@/api/http";
import RadioCheckbox from "@/ui/Radio-Checkbox";
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        BottomButton,
        RadioCheckbox,
        Freezeframe
    },
    data() {
        return {
            classes: [],
            is_selected: true,
            code: '',
            name: '',
            description: ''
        }
    },
    mounted() {
        to_top()
        this.init()
    },
    methods: {
        async init(){
            let { data } = await http.get('statement-of-use-extension/step-3/'  + this.$route.params.key);

            if (data.res) {
                this.code = data.data.data.code
                this.name = data.data.data.name
                this.description = data.data.data.description

                this.classes = data.data.data.classes
                for (let i = 0; i < this.classes.length; i++) {
                    if (this.classes[i].code == this.$route.params.class) {
                        this.is_selected = this.classes[i].is_selected
                        this.code = this.classes[i].code
                        this.name = this.classes[i].name
                        this.description = this.classes[i].description
                    }
                }

                this.$store.commit('header/setTotal', data.data.data.total)
            }
        },
        back(){
            if (this.prev_code) {
                this.$router.push({ path: '/statement-of-use-extension/step-3/' + this.prev_code + '/' + this.$route.params.key })
            } else {
                this.$router.push({ path: '/statement-of-use-extension/step-2/' + this.$route.params.key })
            }
        },
        async next(){
            let { data } = await http.post('statement-of-use-extension/step-3/' + this.$route.params.class + '/' + this.$route.params.key, {
                is_selected: this.is_selected
            });

            if (data.res) {
                if (this.next_code) {
                    this.$router.push({ path: '/statement-of-use-extension/step-3/' + this.next_code + '/' + this.$route.params.key })
                } else {
                    this.$router.push({ path: '/statement-of-use-extension/step-4/' + this.$route.params.key })
                }
            }
        }
    },
    computed: {
        countElements() {
            return this.classes.length ? 6 + this.classes.length : 0
        },
        currentElement() {
            let num = 4

            for (let i = 0; i < this.classes.length; i++) {
                if (this.classes[i].code == this.$route.params.class) {
                    num += i + 1
                }
            }

            return this.classes.length ? num : 0
        },
        prev_code() {
            for (let i = 0; i < this.classes.length; i++) {
                if (this.classes[i].code == this.$route.params.class && typeof this.classes[i - 1] !== 'undefined') {
                    return this.classes[i - 1]['code']
                }
            }
        },
        next_code() {
            for (let i = 0; i < this.classes.length; i++) {
                if (this.classes[i]['code'] == this.$route.params.class && typeof this.classes[i + 1] !== 'undefined') {
                    return this.classes[i + 1]['code']
                }
            }
        },
    }
}
</script>

